'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var isString = require('lodash/isString');
var translation = require('@templafy/translation');
var hooks_useUUID = require('../../hooks/useUUID.js');
var FieldContext = require('../../_chunks/FieldContext-DI94tJqT.js');
var BaseTextInput = require('../../_chunks/BaseTextInput-CHJ9_GE-.js');
var components_visuallyHidden_VisuallyHidden = require('../visuallyHidden/VisuallyHidden.js');
var utilities_combineClasses = require('../../_chunks/combineClasses-5P8GTQkg.js');
var useDevelopmentEffect = require('../../_chunks/useDevelopmentEffect-DGG0KnB_.js');
require('../form/FormContext.js');
require('../../_chunks/useInputAccessibilityProps-uzRyF5PP.js');
require('../../utilities/createComponentNamespace.js');
require('../../utilities/a11yIgnore.js');
require('../../_chunks/BaseButton-DDcpn9-P.js');
require('../../hooks/useCombinedRefs.js');
require('../../icons/IconLoading.js');
require('../../icons/Icon.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var isString__default = /*#__PURE__*/_interopDefault(isString);

const ensureArray = (value) => [value].flat();

const TextInput = react.forwardRef(({ testId, className, style, onChange, disabled: _disabled, readOnly: _readOnly, required: _required, size: _size, status: _status, prefix, suffix, 'aria-describedby': ariaDescribedBy, ...props }, ref) => {
    const prefixId = hooks_useUUID.useUUID({ prefix: 'prefix' });
    const suffixId = hooks_useUUID.useUUID({ prefix: 'suffix' });
    const { disabled, readOnly, required, size, status } = FieldContext.useSynchronizedProps({
        disabled: _disabled,
        readOnly: _readOnly,
        required: _required,
        size: _size,
        status: _status,
        inputType: 'text',
    });
    const prefixArray = ensureArray(prefix).filter(Boolean);
    const hasTextPrefix = prefixArray.some((prefix) => isString__default.default(prefix));
    const suffixArray = ensureArray(suffix).filter(Boolean);
    const hasTextSuffix = suffixArray.some((prefix) => isString__default.default(prefix));
    useDevelopmentEffect.useDevelopmentEffect(() => {
        const textPrefixes = ensureArray(prefix).filter((p) => isString__default.default(p));
        const textSuffix = ensureArray(suffix).filter((s) => isString__default.default(s));
        if (textPrefixes.length > 1) {
            console.error('[TextInput] Maximum 1 text prefix is allowed. Using multiple text prefixes will break accessibility.');
        }
        if (textSuffix.length > 1) {
            console.error('[TextInput] Maximum 1 text suffix is allowed. Using multiple text suffixes will break accessibility.');
        }
    }, [prefix, suffix]);
    return (jsxRuntime.jsx(BaseTextInput.BaseTextInputNamespace, { wrapperProps: { testId, className, style }, onValueChange: onChange, disabled: disabled, readOnly: readOnly, required: required, size: size, status: status, startAdornment: prefixArray.map((prefix) => (jsxRuntime.jsx(AdornmentComponent, { id: hasTextPrefix ? prefixId : undefined, position: "prefix", disabled: disabled || readOnly, children: prefix }, isString__default.default(prefix) ? prefix : prefix.displayName))), endAdornment: suffixArray.map((suffix) => (jsxRuntime.jsx(AdornmentComponent, { id: hasTextSuffix ? suffixId : undefined, position: "suffix", disabled: disabled || readOnly, children: suffix }, isString__default.default(suffix) ? suffix : suffix.displayName))), "aria-describedby": utilities_combineClasses.combineNullableStrings(ariaDescribedBy, hasTextPrefix && prefixId, hasTextSuffix && suffixId), ...props, ref: ref }));
});
TextInput.displayName = 'TextInput';
const AdornmentComponent = ({ id, position, disabled, children, }) => {
    const translator = translation.useTranslator();
    return isString__default.default(children) ? (jsxRuntime.jsxs(BaseTextInput.BaseTextInputNamespace.AdornmentText, { id: id, children: [jsxRuntime.jsxs(components_visuallyHidden_VisuallyHidden.VisuallyHidden, { children: [translator.uiComponentsTextAdornmentPositionDescription({
                        position,
                    }), ' '] }), children] })) : (jsxRuntime.jsx(BaseTextInput.BaseTextInputNamespace.AdornmentIcon, { disabled: disabled, icon: children }));
};

exports.TextInput = TextInput;
//# sourceMappingURL=TextInput.js.map
